export const CLIENT_INFO_TYPES = {
  DIETS_PAGE_INIT: "diets/page-init",
  MAIN: "main",
  BODY: "body",
  BODYMAIN: "bodymain",
  TRAINING: "training",
};
